module.exports = __webpack_public_path__ + "img/draw-success-header.f5874934.png";